import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'

// import auth from './auth';
import { auth } from './auth.module';

const API_URL = 'http://103.153.62.26:8085/api/'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        question: {}
    },
    actions: {
        async userDetail(context, user_id) {
            await axios.get(`${user_id}`)
                .then((response) => {
                    context.commit('setUserDetail', response.data.data)
                    // console.log(response.data.data)
                })
        },
        async profiling(context, question){
            await axios.get(API_URL + `profiling?${question}`)
            .then((response) => {
                context.commit('setProfiling', response.data.data)
                // console.log(response.data.data)
            })
        }
    },
    mutations: {
        setUserDetail(state, data) {
            state.user = data
            // console.log(state.user)
            localStorage.setItem('id',state.user.id)
            // console.log(localStorage)
        },
        setProfiling(state, data) {
            state.question = data
            // console.log(state.question)
            // localStorage.setItem('id',state.user.id)
            // console.log(localStorage)
        },
    },
    getters: {
        getuser(state){
            return state.user
        },
        getquestion(state){
            return state.question
        }
    },
    modules: {
        auth
    }
});